import {useEffect} from 'react'

import {dispatch, useSelector} from '../../store.js'
import {STOCKTAKE_DETAIL_PAGE} from '../../common/constants/Pages.js'
import {setCurrentPage} from '../../redux/actions/ui/index.js'
import {
  setupStocktakeDetailForm,
  removeStocktakeDetailForm,
  getCurrentDetailStocktake,
  stocktakeDetailReferenceIDSelector,
} from './stocktakeDetailFunctions.js'

export default function StocktakeDetailLocationListener() {
  const referenceID = useSelector(stocktakeDetailReferenceIDSelector)

  useEffect(() => {
    if (!referenceID) {
      return
    }

    setupStocktakeDetailForm()

    dispatch(setCurrentPage(STOCKTAKE_DETAIL_PAGE))

    getCurrentDetailStocktake()

    return () => removeStocktakeDetailForm()
  }, [referenceID])

  return null
}
